import React from 'react'
import logo from '../../logo.png'
import {
    FaInstagram,
    FaTwitter,
    FaGithub,
    FaLinkedin,
    FaFacebook
} from 'react-icons/fa'
import './footer.css'

function Footer({
    FbLink,
    instaLink,
    TwitLink,
    LinkdLink,
    GitHubLink
}) {
    return (
        <div className='footer'>
            <div className='footer-container'>
                <div className='site-logo'>
                    <img src={logo} alt='logo' />
                </div>
                <div className='site-title'>
                    <h4>The Haris Khan</h4>
                    <p>+92 341 6353213</p>
                    <p>harisa715@gmail.com</p>
                </div>
                <div className='social-media'>
                    <a 
                    href={FbLink}
                    target='_blank'
                    rel="noopener noreferrer"
                    aria-label='Facebook'
                    className='social-icon-link'>
                        <FaFacebook />
                    </a>
                    <a 
                    href={instaLink}
                    target='_blank'
                    rel="noopener noreferrer"
                    aria-label='Instagram'
                    className='social-icon-link'>
                        <FaInstagram />
                    </a>
                    <a 
                    href={TwitLink}
                    target='_blank'
                    rel="noopener noreferrer"
                    aria-label='Twitter'
                    className='social-icon-link'>
                        <FaTwitter />
                    </a>
                    <a 
                    href={LinkdLink}
                    target='_blank'
                    rel="noopener noreferrer"
                    aria-label='LinkedIn'
                    className='social-icon-link'>
                        <FaLinkedin />
                    </a>
                    <a 
                    href={GitHubLink}
                    target='_blank'
                    rel="noopener noreferrer"
                    aria-label='Github'
                    className='social-icon-link'>
                        <FaGithub />
                    </a>
                </div>
            </div>
            <div className='btn--and--copy'>
                <p className='copyright'>Copyright © {new Date().getFullYear()}</p>
                {/* <Link to='/' className='Go-up-btn'>
                    <FaArrowUp />
                </Link> */}
            </div>
        </div>
    )
}

export default Footer
